import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import {
  stepPersonalDetailsBuilderUI,
  emailExistBuilderUI
} from './personal-details.mappers';
import { Observable } from 'rxjs';
import { EmailExist } from './personal-details.model';
@Injectable({
  providedIn: 'root'
})
export class PersonalDetailsService {
  constructor(private _http: HttpClient) {}
  baseUrl = environment.apiUrl;

  setPersonalDetails(details) {
    return this._http
      .post(`${this.baseUrl}/users`, details)
      .pipe(map(stepPersonalDetailsBuilderUI));
  }

  checkEmailExist(email): Observable<EmailExist> {
    return this._http
      .post(`${this.baseUrl}/users/check-email`, email)
      .pipe(map(emailExistBuilderUI));
  }
}
